import { useRef, useState } from "react";
import { Box } from "@mui/material";

import { UploadCSV as UploadZip } from "components";

import { useToaster } from "hooks";
import { postCall_v2 } from "services";

import { success, error, JOMS_API_BASE_V1_URL } from "constants";

const DocumentUpload = () => {
  const [isFileUploading, setIsFileUploading] = useState(false);
  const zipUploadRef = useRef();
  const triggerToaster = useToaster();

  /**
   * @description callback fn on file upload
   */
  const fileUploadCallback = async (file) => {
    setIsFileUploading(true);
    if (file) {
      try {
        const formData = new FormData();
        formData.append("file", file);
        const res = await postCall_v2(
          `${JOMS_API_BASE_V1_URL}/v1/ledger-document-upload/upload-ledger-zip`,
          formData,
        );
        if (res?.data?.isSuccess) {
          triggerToaster(
            res?.data?.message || "File uploaded successfully.",
            success,
          );
        }
      } catch (err) {
        triggerToaster(
          err?.data?.errorMessage || `Error occurred, please try again`,
          error,
        );
      } finally {
        setIsFileUploading(false);
        zipUploadRef?.current?.resetFile();
      }
    }
  };

  return (
    <Box mb={8}>
      <UploadZip
        headerText={"Upload CN / DN PDFs"}
        fileCallBackFn={fileUploadCallback}
        allowedMaxSize={100}
        ref={zipUploadRef}
        isLoading={isFileUploading}
        fileType={"zip"}
        subHeaderText="(Upload ZIP with CN/DN PDFs. Use CN or DN number as file name)"
      />
    </Box>
  );
};

export default DocumentUpload;
